import { TagColors } from "../../common";
import { ShopFilter } from "./shop-summary";
export var AlertKeyEnum;
(function (AlertKeyEnum) {
    AlertKeyEnum["FlightKey"] = "FlightKey";
})(AlertKeyEnum || (AlertKeyEnum = {}));
export var WatchState;
(function (WatchState) {
    WatchState[WatchState["NotWatching"] = 0] = "NotWatching";
    WatchState[WatchState["Watching"] = 1] = "Watching";
    WatchState[WatchState["JustWatched"] = 2] = "JustWatched";
    WatchState[WatchState["InProcess"] = 3] = "InProcess";
})(WatchState || (WatchState = {}));
export var CreateWatchAlertResponseEnum;
(function (CreateWatchAlertResponseEnum) {
    CreateWatchAlertResponseEnum["Success"] = "Success";
    CreateWatchAlertResponseEnum["Failure"] = "Failure";
})(CreateWatchAlertResponseEnum || (CreateWatchAlertResponseEnum = {}));
export var MessageMethodEnum;
(function (MessageMethodEnum) {
    MessageMethodEnum["Email"] = "Email";
    MessageMethodEnum["MultiMethod"] = "MultiMethod";
    MessageMethodEnum["Push"] = "Push";
    MessageMethodEnum["Sms"] = "Sms";
})(MessageMethodEnum || (MessageMethodEnum = {}));
export var getWatchDetails = function (watch, context, formatDate, getFilterLabel
// buyString: string,
// waitString: string
) {
    var _a, _b;
    var showFilterLabel = [
        ShopFilter.NonStop,
        ShopFilter.NonStopNoLCC,
        ShopFilter.NoLCC,
    ].includes(watch.key.value.filter);
    return {
        // titleTag: {
        //   label: watch.recommendation === "Buy" ? buyString : waitString,
        //   type: watch.recommendation === "Buy" ? TagColors.GREEN : TagColors.GREY,
        // },
        subtitleTag: showFilterLabel
            ? {
                label: getFilterLabel(watch.key.value.filter),
                type: TagColors.GREY,
            }
            : undefined,
        title: "".concat(((_a = context === null || context === void 0 ? void 0 : context.airports[watch.key.value.origin.code]) === null || _a === void 0 ? void 0 : _a.cityName) ||
            watch.key.value.origin.code, " to ").concat(((_b = context === null || context === void 0 ? void 0 : context.airports[watch.key.value.destination.code]) === null || _b === void 0 ? void 0 : _b.cityName) ||
            watch.key.value.destination.code),
        startDate: formatDate(watch.key.value.departureDate),
        endDate: watch.key.value.returnDate
            ? formatDate(watch.key.value.returnDate)
            : undefined,
        subtitle: watch.key.value.returnDate
            ? "Round-trip Flight"
            : "One-way Flight",
    };
};
//# sourceMappingURL=watch-alerts.js.map